import { useEffect, useState } from 'react';
import { useVideo } from '../useVideo';

type RoomStateType = 'disconnected' | 'connected' | 'reconnecting';

export function useRoomState() {
  const { room } = useVideo();
  const [state, setState] = useState<RoomStateType>('disconnected');

  useEffect(() => {
    if (room) {
      const setRoomState = () => setState(room.state as RoomStateType);
      setRoomState();
      room.on('disconnected', setRoomState).on('reconnected', setRoomState).on('reconnecting', setRoomState);
      return () => {
        room.off('disconnected', setRoomState).off('reconnected', setRoomState).off('reconnecting', setRoomState);
      };
    }
  }, [room]);

  return state;
}
